import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-activity-action-modal',
  templateUrl: './activity-action-modal.component.html',
  styleUrls: ['./activity-action-modal.component.scss']
})
export class ActivityActionModalComponent implements OnDestroy {

  url = '';
  sanitizedUrl = '';


  constructor(public dialogRef: MatDialogRef<ActivityActionModalComponent>, private router: Router) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
 }

  close(): void {
    this.dialogRef.close();
  }

  transcript = [
    {
      "role": "user",
      "agent_metadata": null,
      "message": "...",
      "multivoice_message": null,
      "tool_calls": [],
      "tool_results": [],
      "feedback": null,
      "llm_override": null,
      "time_in_call_secs": 6,
      "conversation_turn_metrics": null,
      "rag_retrieval_info": null,
      "llm_usage": null,
      "interrupted": false,
      "original_message": null,
      "source_medium": "audio"
    },
    {
      "role": "agent",
      "agent_metadata": {
        "agent_id": "agent_8601kgh55x3derjbjej36rfdep4p",
        "branch_id": "agtbrch_4701kgh55ysmfczs5ytg5rhtjwt3",
        "workflow_node_id": null
      },
      "message": "Hello, are you still there? How can I assist you with your property inquiry today?",
      "multivoice_message": null,
      "tool_calls": [],
      "tool_results": [],
      "feedback": null,
      "llm_override": null,
      "time_in_call_secs": 7,
      "conversation_turn_metrics": {
        "metrics": {
          "convai_llm_service_ttf_sentence": {
            "elapsed_time": 0.7289201040002808
          },
          "convai_llm_service_ttfb": {
            "elapsed_time": 0.5011466550004116
          },
          "convai_llm_service_tt_last_sentence": {
            "elapsed_time": 0.9192777369999021
          },
          "convai_tts_service_ttfb": {
            "elapsed_time": 0.14102015600019513
          }
        },
        "convai_asr_provider": null
      },
      "rag_retrieval_info": null,
      "llm_usage": {
        "model_usage": {
          "gpt-4.1-mini": {
            "input": {
              "tokens": 1059,
              "price": 0.0004236
            },
            "input_cache_read": {
              "tokens": 0,
              "price": 0.0
            },
            "input_cache_write": {
              "tokens": 0,
              "price": 0.0
            },
            "output_total": {
              "tokens": 18,
              "price": 0.0000288
            }
          }
        }
      },
      "interrupted": false,
      "original_message": null,
      "source_medium": null
    },
    {
      "role": "user",
      "agent_metadata": null,
      "message": "I want to buy a property in Bangalore.",
      "multivoice_message": null,
      "tool_calls": [],
      "tool_results": [],
      "feedback": null,
      "llm_override": null,
      "time_in_call_secs": 13,
      "conversation_turn_metrics": {
        "metrics": {
          "convai_asr_trailing_service_latency": {
            "elapsed_time": 0.11132940700008476
          }
        },
        "convai_asr_provider": "Original ASR"
      },
      "rag_retrieval_info": null,
      "llm_usage": null,
      "interrupted": false,
      "original_message": null,
      "source_medium": "audio"
    },
    {
      "role": "agent",
      "agent_metadata": {
        "agent_id": "agent_8601kgh55x3derjbjej36rfdep4p",
        "branch_id": "agtbrch_4701kgh55ysmfczs5ytg5rhtjwt3",
        "workflow_node_id": null
      },
      "message": "Hello, this is Priya calling from Calsoft Realty. I'm calling regarding your recent enquiry about property listings. Is this a good time to talk?",
      "multivoice_message": null,
      "tool_calls": [],
      "tool_results": [],
      "feedback": null,
      "llm_override": null,
      "time_in_call_secs": 17,
      "conversation_turn_metrics": {
        "metrics": {
          "convai_llm_service_ttf_sentence": {
            "elapsed_time": 0.5805739279994668
          },
          "convai_llm_service_ttfb": {
            "elapsed_time": 0.3970553059998565
          },
          "convai_llm_service_tt_last_sentence": {
            "elapsed_time": 0.8208718139994744
          },
          "convai_tts_service_ttfb": {
            "elapsed_time": 0.19149980099973618
          }
        },
        "convai_asr_provider": null
      },
      "rag_retrieval_info": null,
      "llm_usage": {
        "model_usage": {
          "gpt-4.1-mini": {
            "input": {
              "tokens": 1094,
              "price": 0.0004376
            },
            "input_cache_read": {
              "tokens": 0,
              "price": 0.0
            },
            "input_cache_write": {
              "tokens": 0,
              "price": 0.0
            },
            "output_total": {
              "tokens": 30,
              "price": 0.000048
            }
          }
        }
      },
      "interrupted": false,
      "original_message": null,
      "source_medium": null
    },
    {
      "role": "user",
      "agent_metadata": null,
      "message": "Yeah.",
      "multivoice_message": null,
      "tool_calls": [],
      "tool_results": [],
      "feedback": null,
      "llm_override": null,
      "time_in_call_secs": 26,
      "conversation_turn_metrics": {
        "metrics": {
          "convai_asr_trailing_service_latency": {
            "elapsed_time": 0.13036230700072338
          }
        },
        "convai_asr_provider": "Original ASR"
      },
      "rag_retrieval_info": null,
      "llm_usage": null,
      "interrupted": false,
      "original_message": null,
      "source_medium": "audio"
    },
    {
      "role": "agent",
      "agent_metadata": {
        "agent_id": "agent_8601kgh55x3derjbjej36rfdep4p",
        "branch_id": "agtbrch_4701kgh55ysmfczs5ytg5rhtjwt3",
        "workflow_node_id": null
      },
      "message": "Great! Are you looking for an apartment, a villa, or a plot in Bangalore?",
      "multivoice_message": null,
      "tool_calls": [],
      "tool_results": [],
      "feedback": null,
      "llm_override": null,
      "time_in_call_secs": 28,
      "conversation_turn_metrics": {
        "metrics": {
          "convai_llm_service_ttf_sentence": {
            "elapsed_time": 0.4148367799998596
          },
          "convai_llm_service_ttfb": {
            "elapsed_time": 0.41405332799968164
          },
          "convai_llm_service_tt_last_sentence": {
            "elapsed_time": 0.6280093679997663
          },
          "convai_tts_service_ttfb": {
            "elapsed_time": 0.11611563499991462
          }
        },
        "convai_asr_provider": null
      },
      "rag_retrieval_info": null,
      "llm_usage": {
        "model_usage": {
          "gpt-4.1-mini": {
            "input": {
              "tokens": 1134,
              "price": 0.0004536
            },
            "input_cache_read": {
              "tokens": 0,
              "price": 0.0
            },
            "input_cache_write": {
              "tokens": 0,
              "price": 0.0
            },
            "output_total": {
              "tokens": 18,
              "price": 0.0000288
            }
          }
        }
      },
      "interrupted": false,
      "original_message": null,
      "source_medium": null
    },
    {
      "role": "user",
      "agent_metadata": null,
      "message": "Villa.",
      "multivoice_message": null,
      "tool_calls": [],
      "tool_results": [],
      "feedback": null,
      "llm_override": null,
      "time_in_call_secs": 34,
      "conversation_turn_metrics": {
        "metrics": {
          "convai_asr_trailing_service_latency": {
            "elapsed_time": 0.13928261599994585
          }
        },
        "convai_asr_provider": "Original ASR"
      },
      "rag_retrieval_info": null,
      "llm_usage": null,
      "interrupted": false,
      "original_message": null,
      "source_medium": "audio"
    },
    {
      "role": "agent",
      "agent_metadata": {
        "agent_id": "agent_8601kgh55x3derjbjej36rfdep4p",
        "branch_id": "agtbrch_4701kgh55ysmfczs5ytg5rhtjwt3",
        "workflow_node_id": null
      },
      "message": "Thank you for letting me know. Which location in Bangalore are you considering for the villa?",
      "multivoice_message": null,
      "tool_calls": [],
      "tool_results": [],
      "feedback": null,
      "llm_override": null,
      "time_in_call_secs": 36,
      "conversation_turn_metrics": {
        "metrics": {
          "convai_llm_service_ttf_sentence": {
            "elapsed_time": 0.5284249170008479
          },
          "convai_llm_service_ttfb": {
            "elapsed_time": 0.45728151200000866
          },
          "convai_llm_service_tt_last_sentence": {
            "elapsed_time": 0.634488132000115
          },
          "convai_tts_service_ttfb": {
            "elapsed_time": 0.14158485999996628
          }
        },
        "convai_asr_provider": null
      },
      "rag_retrieval_info": null,
      "llm_usage": {
        "model_usage": {
          "gpt-4.1-mini": {
            "input": {
              "tokens": 1162,
              "price": 0.0004648
            },
            "input_cache_read": {
              "tokens": 0,
              "price": 0.0
            },
            "input_cache_write": {
              "tokens": 0,
              "price": 0.0
            },
            "output_total": {
              "tokens": 18,
              "price": 0.0000288
            }
          }
        }
      },
      "interrupted": false,
      "original_message": null,
      "source_medium": null
    },
    {
      "role": "user",
      "agent_metadata": null,
      "message": "Electronic City",
      "multivoice_message": null,
      "tool_calls": [],
      "tool_results": [],
      "feedback": null,
      "llm_override": null,
      "time_in_call_secs": 43,
      "conversation_turn_metrics": {
        "metrics": {
          "convai_asr_trailing_service_latency": {
            "elapsed_time": 0.1893465049997758
          }
        },
        "convai_asr_provider": "Original ASR"
      },
      "rag_retrieval_info": null,
      "llm_usage": null,
      "interrupted": false,
      "original_message": null,
      "source_medium": "audio"
    },
    {
      "role": "agent",
      "agent_metadata": {
        "agent_id": "agent_8601kgh55x3derjbjej36rfdep4p",
        "branch_id": "agtbrch_4701kgh55ysmfczs5ytg5rhtjwt3",
        "workflow_node_id": null
      },
      "message": "Electronic City is a popular choice. Do you have a budget range in mind for the villa?",
      "multivoice_message": null,
      "tool_calls": [],
      "tool_results": [],
      "feedback": null,
      "llm_override": null,
      "time_in_call_secs": 45,
      "conversation_turn_metrics": {
        "metrics": {
          "convai_llm_service_ttf_sentence": {
            "elapsed_time": 0.5617491090006297
          },
          "convai_llm_service_ttfb": {
            "elapsed_time": 0.5224290180003663
          },
          "convai_llm_service_tt_last_sentence": {
            "elapsed_time": 0.6747597470002802
          },
          "convai_tts_service_ttfb": {
            "elapsed_time": 0.1657197439999436
          }
        },
        "convai_asr_provider": null
      },
      "rag_retrieval_info": null,
      "llm_usage": {
        "model_usage": {
          "gpt-4.1-mini": {
            "input": {
              "tokens": 1190,
              "price": 0.000476
            },
            "input_cache_read": {
              "tokens": 0,
              "price": 0.0
            },
            "input_cache_write": {
              "tokens": 0,
              "price": 0.0
            },
            "output_total": {
              "tokens": 19,
              "price": 0.0000304
            }
          }
        }
      },
      "interrupted": false,
      "original_message": null,
      "source_medium": null
    },
    {
      "role": "user",
      "agent_metadata": null,
      "message": "1 crore",
      "multivoice_message": null,
      "tool_calls": [],
      "tool_results": [],
      "feedback": null,
      "llm_override": null,
      "time_in_call_secs": 52,
      "conversation_turn_metrics": {
        "metrics": {
          "convai_asr_trailing_service_latency": {
            "elapsed_time": 0.2067842140004359
          }
        },
        "convai_asr_provider": "Original ASR"
      },
      "rag_retrieval_info": null,
      "llm_usage": null,
      "interrupted": false,
      "original_message": null,
      "source_medium": "audio"
    },
    {
      "role": "agent",
      "agent_metadata": {
        "agent_id": "agent_8601kgh55x3derjbjej36rfdep4p",
        "branch_id": "agtbrch_4701kgh55ysmfczs5ytg5rhtjwt3",
        "workflow_node_id": null
      },
      "message": "Thank you for sharing your budget. When are you planning to purchase the villa — immediately or in the next few months?",
      "multivoice_message": null,
      "tool_calls": [],
      "tool_results": [],
      "feedback": null,
      "llm_override": null,
      "time_in_call_secs": 55,
      "conversation_turn_metrics": {
        "metrics": {
          "convai_llm_service_ttf_sentence": {
            "elapsed_time": 0.5391697539998859
          },
          "convai_llm_service_ttfb": {
            "elapsed_time": 0.4692210149996754
          },
          "convai_llm_service_tt_last_sentence": {
            "elapsed_time": 0.678119412000342
          },
          "convai_tts_service_ttfb": {
            "elapsed_time": 0.15060146500036353
          }
        },
        "convai_asr_provider": null
      },
      "rag_retrieval_info": null,
      "llm_usage": {
        "model_usage": {
          "gpt-4.1-mini": {
            "input": {
              "tokens": 67,
              "price": 0.0000268
            },
            "input_cache_read": {
              "tokens": 1152,
              "price": 0.0001152
            },
            "input_cache_write": {
              "tokens": 0,
              "price": 0.0
            },
            "output_total": {
              "tokens": 24,
              "price": 0.0000384
            }
          }
        }
      },
      "interrupted": false,
      "original_message": null,
      "source_medium": null
    }
  ];


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
